<template>

<core-card-foot-progress :value="winPercent" :color="item.game.color" :invalid="winPercent === false" :text="field.label" />

</template>

<script>

export default {

	props: ['item', 'field'],

	data: function() {

		return {

			winPercent: 0

		}

	},

	watch: {

		item: {

			deep: true,

			handler: function() {

				this.onChange()

			}

		}

	},

	created: function() {

		this.onChange()

	},

	computed: {

		history: function() {

			if (this.isUser && this.item.revisions) {

				return (this.item.revisions) ? this.item.revisions.history : []

			} else {

				return this.item.trend || []

			}

		}

    },

	methods: {

		hours: function(minutes) {

			return Math.ceil(minutes / 60)

		},

		onChange: function() {

			if (this.item.record.results) {

				this.winPercent = (100 / this.item.record.results) * this.item.record.wins

			} else {

				this.winPercent = false

			}

        }

    }

}

</script>

<style scoped>

</style>
